import React from "react";
import { Button, Stack } from "@mui/material";
import { Add, List } from "@mui/icons-material";
import { DocumentReference } from "../../../utils/taskpane";

interface ReferenceListProps {
  onAddReference: () => void;
  onEditReference: (reference: DocumentReference) => void;
  onViewExisting: () => void;
}

const ReferenceList = ({ onAddReference, onViewExisting }: ReferenceListProps) => {
  return (
    <Stack direction="column" spacing={2} p={2}>
      <Button variant="contained" startIcon={<Add />} onClick={onAddReference}>
        Insert New Reference
      </Button>
      <Button variant="outlined" startIcon={<List />} onClick={onViewExisting}>
        View Existing References
      </Button>
    </Stack>
  );
};

export default ReferenceList;
